export enum PropertySortByField {
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at',
    ADDRESS = 'address'
}